import * as http from '../utils/request'
import {getUserId, getUserName,getLoginData} from '@/utils/auth'

export function login({ username, password, type }) {
  return http.postJSON('/v1/admin/control/sessions', { username, password, type })
}

export function adminLogin({ username, password, type }) {
  return http.postJSON('/v1/admin/control/sessions/tenant-manager', { username, password, type })
}

export function register({ username, password,registerCode }) {
  return http.postJSON('/v1/subusers', { username, password,parentStr:registerCode ,accessControllerList:["62f3ace26258cfb9289ec140"]})
}

export function getUserInfo() {
  return http.get("/v1/admin/tenant/users/self");
}

export function getInfo(token) {
  return http.get('/user/info', { token })
}

export function logout() {
  return http.get('v1/auth/logout')
}

export function lastPackage(pkgtype) {
  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;

  return http.get2(`v1/out-filemanager/tenants/${tenantId}/package/lastPackage`, {"pkgtype": pkgtype});
}

export async function packageInfo() {
  var master=await lastPackage("master_firmware_2001_3.0");
  var pack=await lastPackage("slave_firmware_6_3.0");
 var ems=await lastPackage("EMS_V2_firmware");
  return  {master,pack,ems};
}


export function queryList(params) {
  return http.get('/user/findPage', { ...params })
}

export function insert(params) {
  return http.postJSON('/user/insert', params)
}

export function update(params) {
  return http.postJSON("user/update",{...params})
}

export function resetPwd({id,password}) {
  return http.postJSON("/user/updatePassword",{id,password})
}

export function updatePassword({password,oldpassword}) {

  let params ={
    password: password,
    origin_password: oldpassword,
  }

  return http.putJSON("/v1/admin/tenant/users/self/password?update_pwd_way=3",params)

  // let data=getLoginData()
  // let params={
  //   parent:data.parent,
  //   parents:data.parents,
  //   password:password,
  //   oldpassword:oldpassword,
  // }

  // return http.putJSON("/v1/subusers/"+getUserName(),params)
}
export function restPassword1({id,password}) {
  let data=getLoginData()
  let params={
    // parent:data.parent,
    // parents:data.parents,
    password:password,
  }

  let userInfo = getLoginData();
  let tenantId = userInfo.tenant_id;

  return http.postJSON(`/v1/admin/tenant/tenants/${tenantId}/users/${id}/reset-password?password=${password}`, params)
}


export function findUserRole(userId) {
   return http.get("/user/findUserRole",{userId})
}

export function insertRole(params) {
  return http.postJSON("/user/insertRelation",params)
}
